import { Component } from '@angular/core';

@Component({
  selector: 'app-accounts',
  imports: [],
  templateUrl: './accounts.component.html',
  styleUrl: './accounts.component.css',
})
export class AccountsComponent {

}
